var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 8H18.2C17.0065 8 15.8619 8.47411 15.018 9.31802C14.1741 10.1619 13.7 11.3065 13.7 12.5V15.2H11V18.8H13.7V26H17.3V18.8H20L20.9 15.2H17.3V12.5C17.3 12.2613 17.3948 12.0324 17.5636 11.8636C17.7324 11.6948 17.9613 11.6 18.2 11.6H20.9V8Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaceBook);
export default __webpack_public_path__ + "static/media/iconFaceBook.cdb06903a3e9b73b6d9fd6265462f964.svg";
export { ForwardRef as ReactComponent };